import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Counter from "@components/counter";
import Icon from "@components/icon";

import styles from "../Burger.scss";

const cx = classnames.bind(styles);

const Label = ({ beforeIconName, children, afterIconName, counter }) => (
  <>
    <span className={cx("burger-button-label")}>
      <span className={cx("burger-button-before")}>
        {beforeIconName && (
          <Icon
            name={beforeIconName}
            fill="var(--glz-color-neutral-tone-5)"
            size="s"
          />
        )}
      </span>
      {children}
    </span>
    <span className={cx("burger-button-after")}>
      {!!counter && counter > 0 && (
        <Counter active className={cx("counter")} maxValue={99} size="medium">
          {counter}
        </Counter>
      )}

      {afterIconName && (
        <Icon
          name={afterIconName}
          fill="var(--glz-color-neutral-tone-5)"
          size="s"
        />
      )}
    </span>
  </>
);

Label.propTypes = {
  beforeIconName: PropTypes.string,
  afterIconName: PropTypes.string,
  children: PropTypes.node,
  counter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Label;
